module.exports = __webpack_public_path__ + "static/media/M2G.118d9ba3.png";